export default __webpack_public_path__ + "static/media/product25_sportshoe.7680893c.webp";